<template>
  <section class="view">
    <intro class="intro" />
  </section>
</template>

<script>
import Intro from "../components/Intro";

export default {
  name: "home",
  components: {
    Intro
  }
};
</script>